export default __webpack_public_path__ + "static/illustration-1-cdb57e1a992b8c7b5be254b3f074aa99.png";